import Modal, { useModal } from './utils/Modal.js';
import { useEffect, useRef, useState } from 'react';

const AideModalButton = () => {
  const [aideAvailable, setAideAvailable] = useState(false);
  const aideRef = useRef();
  const { open: openModal, setOpen: setOpenModal } = useModal(false);

  useEffect(() => {
    const template = document.querySelector('#aide-recherche-avancee-template');
    if (!template) {
      return;
    }

    setAideAvailable(true);
    const clonedElement = document.importNode(template.content, true);
    aideRef.current.appendChild(clonedElement);
  }, []);

  return (
    <>
      {aideAvailable ? (
        <button
          type="button"
          className="expert-form-help-btn"
          onClick={() => setOpenModal(true)}
        >
          Aide à la recherche avancée
        </button>
      ) : null}
      {/* Qu'importe que l'aide soit disponible ou non, il faut tout de même ajouter la Modal ou sinon aideRef.current sera undefined plus haut */}
      <Modal
        titre="Aide en ligne"
        className="aide-modal"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <div ref={aideRef}></div>
      </Modal>
    </>
  );
};
AideModalButton.propTypes = {};

export default AideModalButton;
